import React, { useState } from "react";
import styles from "./DepositHistory.module.css";
import { FiEdit2 } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import Dropdown from "../../components/Dropdown/Dropdown";
import SearchBar from "../../components/SearchBar/SearchBar";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import DynamicTable from "../../components/DynamicTable/DynamicTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import IconAndName from "../../components/IconAndName/IconAndName";
import { MdOutlineTextSnippet } from "react-icons/md";
import CopyRight from "../../components/CopyRight/CopyRight";
import { IoMdTrash } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { FaFilePdf, FaRegFilePdf } from "react-icons/fa";
import jsPDF from "jspdf";
import { ImFilePdf } from "react-icons/im";

const data = [
  {
    _id: "s1",
    studentName: "John Jacob",
    description: "Amount Credited",
    amountAdded: 2600,
    amountUsed: 1400,
    recordedBy: "Darshan Sir",
    recordedApp: "Varun",
    transaction: "Added",
  },
  {
    _id: "s2",
    studentName: "Jane Smith",
    description: "Amount Credited",
    amountAdded: 2000,
    amountUsed: 800,
    recordedBy: "Neha Ma’am",
    recordedApp: "Ankit",
    transaction: "Added",
  },
];

const DepositHistory = () => {
  const dispatch = useDispatch();
  const [count, setCount] = useState(7);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

 
  const navigate = useNavigate();

  const handlecreateform = () => {
    dispatch(openModal("addFeePlan"));
  };

  const handleDownloadPDF = (student) => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text("Deposit History", 105, 20, null, null, "center");
    doc.setFontSize(12);
    doc.text(`Student Name: ${student.studentName}`, 20, 40);
    doc.text(`Description: ${student.description}`, 20, 50);
    doc.text(`Amount Added: INR ${student.amountAdded}`, 20, 60);
    doc.text(`Amount Used: INR ${student.amountUsed}`, 20, 70);
    doc.text(`Recorded By: ${student.recordedBy}`, 20, 80);
    doc.text(`App by: ${student.recordedApp}`, 20, 90);
    doc.text(`Transaction: ${student.transaction}`, 20, 100);
    doc.save(`${student.studentName}_deposit_history.pdf`);
  };
  
 

  const headingsData = [
    { title: "Student Name", accessor: "studentName" },
    { title: "Description", accessor: "description" },
    { title: "Amount Added", accessor: "amountAdded" },
    { title: "Amount Used", accessor: "amountUsed" },
    { title: "Recorded by", accessor: "recordedBy" },
    { title: "Transaction", accessor: "transaction" },
    { title: "", accessor: "download" }, // <-- new column
  ];

  const getColumnData = (data) => {
    return data.map((item) => ({
      studentName: <LogoWithName name={item.studentName} />,
      description: item.description || "-",
      amountAdded: `INR ${item.amountAdded || 0}`,
      amountUsed: `INR ${item.amountUsed || 0}`,
      recordedBy: (
        <>
          {item.recordedBy}
          <br />
          <span style={{ fontSize: "12px", opacity: 0.6 }}>
            App by : {item.recordedApp}
          </span>
        </>
      ),
      transaction: item.transaction || "-",
      download: (
        <ImFilePdf
          style={{ cursor: "pointer", color: "var(--Black_Color)" }}
          onClick={() => handleDownloadPDF(item)}
        />
      ),
    }));
  };
  

  const displayData = getColumnData(data);

  return (
    <>
      <div className={styles.mainContainer}>
        <div className={styles.container}>
          
            <h4
              style={{
                color: "var(--Primary_Color)",
                fontWeight: "400",
                marginBottom: "1rem",
                marginLeft:"1rem",
              }}
            >
             Deposit History
            </h4>
          
          {/* 🟩 Result Cards + This Month */}

          {/* 🔍 Search & Filters Row */}
          <div className={styles.totalstudentcard}>
            <div className={styles.studentsection}>
              <div className={styles.search}>
                <SearchBar
                  placeholder="Search Student"
                  onChange={(e) => console.log(e.target.value)}
                />
              </div>
              <div className={styles.filters}>
                <Dropdown
                  label="Student Status"
                  options={["Annual Day", "Freshers"]}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <Dropdown
                  label="Program"
                  options={["Annual Day", "Freshers"]}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <Dropdown
                  label="Group"
                  options={["Group 1", "Group 2"]}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <Dropdown
                  label="Room"
                  options={["Room1", "Room2"]}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <IoMdTrash
                  size={26}
                  style={{
                    marginTop: "0.5rem",

                    opacity: 0.4,
                    color: "var(--Black_Color)",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    dispatch(openModal("delete"));
                  }}
                />
              </div>
            </div>

            {/* Student Data Table */}
            <div className={styles.dynamicdata}>
              <DynamicTable
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>
            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </>
  );
};

export default DepositHistory;
